import React, { FunctionComponent, useState } from 'react';
import { View, Text, Card, InfoIcon } from '@upstox/upstox-ui';
import * as css from './RegistrarInfoCard.style';
import { POPUP_TEXT_1, POPUP_TEXT_2 } from './constants';
import InfoPopup from '../../../components/InfoPopup/InfoPopup';

type Props = {
  name: string;
  contactNumber: string;
  email: string;
};

const RegistrarInfoCard: FunctionComponent<Props> = ({
  name,
  contactNumber,
  email,
}) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(!showModal);
  };

  return (
    <View css={css.cardWidth}>
      <Card width="full" css={css.cardStyles}>
        <View flexDirection="column" css={css.cardWrapper}>
          <View alignItems="center" css={css.titleWrapper}>
            <View css={css.registrarTitle}>
              <Text size="l" weight="heading2" color="background.upstoxLogo">
                Registrar information
              </Text>
            </View>
          </View>
          <View flexDirection="column" style={{ width: '100%' }}>
            <View css={css.listItem}>
              <View css={css.labelBlock}>
                <Text color="text.2">Name</Text>
              </View>
              <View css={css.valueBlock}>
                <Text color="text.default">{name || '--'}</Text>
              </View>
            </View>
            <View css={css.line1}></View>
            <View css={css.listItem} flexDirection="column">
              <View css={css.labelBlock}>
                <Text color="text.2">Phone number</Text>
              </View>
              <View css={css.valueBlock}>
                <Text color="text.default">{contactNumber || '--'}</Text>
              </View>
            </View>
            <View css={css.line1}></View>
            <View flexDirection="column">
              <View css={css.listItem}>
                <View css={css.labelBlock}>
                  <Text color="text.2">Email ID</Text>
                </View>
                <View css={css.valueBlock}>
                  <Text color="text.default">{email || '-'}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </Card>
      {showModal && (
        <InfoPopup
          title="Registrar information"
          show={showModal}
          onClose={openModal}
        >
          <View flexDirection="column" gap="small">
            <Text color="text.2" variant="body">
              {POPUP_TEXT_1}
            </Text>
            <Text color="text.2" variant="body">
              {POPUP_TEXT_2}
            </Text>
          </View>
        </InfoPopup>
      )}
    </View>
  );
};

export default RegistrarInfoCard;
